import useBasicStores from 'Shared/hooks/useBasicStores'

import { RootStore as CustomerRootStore } from './rootStore/RootStore'

export * from './rootStore/RootStore'
// INJECT_FROM_PLOP_TABLELIST__STORE
export * from './purchaseOrderStore/PurchaseOrderStore'
export * from './authStore/AuthStore'
export * from './customerInvoiceStore/CustomerInvoiceStore'
export * from './siteDocumentStore/SiteDocumentStore'
export * from './backupDocumentStore/BackupDocumentStore'
export * from './biohazardousManifestStore/BiohazardousManifestStore'
export * from './wastestreamStore/WastestreamStore'
export * from './orderStore/OrderStore'
export * from './reportStore/ReportStore'
export * from './companyCategoryStore/CompanyCategoryStore'
export * from './accountCategoryStore/AccountCategoryStore'
export * from './treatmentCategoryStore/TreatmentCategoryStore'
export * from './treatmentMethodStore/TreatmentMethodStore'
export * from './dashboardStore/DashboardStore'
export * from './reportStore/ReportStore'
export * from './treatmentMethodStore/TreatmentMethodStore'
export * from './manifestStore/ManifestStore'
export * from './mouStore/MouStore'
export * from './metadataStore/MetadataStore'
export * from './helpCenterStore/HelpCenterStore'
export * from './analyticStore/AnalyticStore'
export * from './profileStore/ProfileStore'
export * from './metricByPeriodsStore/MetricByPeriodsStore'
export * from './kpiStore/KpiStore'
export * from './locationStore/LocationStore'
export * from './locationByPeriodsStore/LocationByPeriodsStore'
export * from './auditStore/AuditStore'
export * from './registrationDocumentStore/RegistrationDocumentStore'
export * from './serviceLocationStore/ServiceLocationStore'

export const useStores = (): CustomerRootStore => useBasicStores<CustomerRootStore>()
